export default "__VITE_ASSET__74a883f6__"